/* eslint-disable react/destructuring-assignment */
import { useAccount } from "hooks/useAccounts";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import Button from "pages/_components/Button";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { arrayOf, bool, func, number, shape, string } from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { actions as fileActions } from "reducers/files";
import { actions as transactionLinesActions } from "reducers/form/transactionLines";
import { useSelector } from "react-redux";
import { TransactionSign } from "pages/_components/TransactionCard";
import MassiveEcheckTable from "./massiveEcheckTable";

const MassiveEcheckSummaryBody = (props) => {
    const { user } = useSelector((state) => state.session);
    const { id } = useParams();
    const { isDesktop, showMoreData, setShowMoreData } = props;

    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const { formatAccountBody, dispatch } = useAccount();
    const { transaction = {} } = useContext(TransactionContext);

    const { data = {} } = transaction;

    const { processedFileData = props.processedFileData, accountInfo = props.accountInfo, file = props.file } = data;

    const isBackoffice = window.self !== window.top;

    const fetchFromFile = ["PENDING"];

    useEffect(() => {
        if (!isBackoffice) {
            const fileId = (file?.length > 0 && file[0].fileId) || processedFileData?.idFile;

            if (fileId && props.fromTransactionPage && !fetchFromFile.includes(transaction.idTransactionStatus)) {
                dispatch(transactionLinesActions.clearTransactionLines());
                dispatch(
                    transactionLinesActions.listTransactionLinesRequest({
                        id,
                        pageNumber: 1,
                        status: "TODOS",
                        fileId,
                    }),
                );
                dispatch(transactionLinesActions.setPageNumber(0));
            } else if (
                fileId &&
                (!props.fromTransactionPage || fetchFromFile.includes(transaction.idTransactionStatus))
            ) {
                dispatch(transactionLinesActions.clearTransactionLines());
                dispatch(
                    fileActions.getFileContentsRequest(
                        fileId,
                        false,
                        user?.userId,
                        "MassiveEcheq",
                        "load.echeq.massive",
                    ),
                );
                dispatch(transactionLinesActions.initializeEditedLines());
                dispatch(transactionLinesActions.setPageNumber(0));
            }
        }
    }, []);

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    const { fromTransactionPage, isTicket } = props;

    if (fromTransactionPage) {
        return (
            <div className="ticket">
                <div className="ticket__wrapper">
                    <div className="ticket__body echeq-massive-emit">
                        <>
                            <div className="ticket-header-info">
                                <CustomData
                                    dataClass={`amount tag ${
                                        transaction.idTransactionStatus === "FINISHED"
                                            ? "tag-echeq-character"
                                            : "tag-warning"
                                    }`}
                                    titleText="forms.inputFile.massivePayments.totalAmount"
                                    titleTextType="I18N"
                                    valueText={
                                        <FormattedAmount
                                            className="data-label"
                                            currency={processedFileData?.totalAmount?.currency}
                                            quantity={processedFileData?.totalAmount?.quantity}
                                        />
                                    }
                                />
                            </div>
                            <div className="view-more-data-button" id="element-to-ignore">
                                <div className="ticket__divider inside-ticket__body">
                                    <div className="ticket__notch ticket__notch--left"> </div>
                                    <div className="ticket__notch ticket__notch--right"> </div>
                                </div>
                                <Button
                                    aria-expanded={showMoreData ? "true" : "false"}
                                    className="more-button"
                                    label={buttonLabel}
                                    bsStyle="link"
                                    onClick={handleSeeMoreData}
                                    image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                                />
                            </div>
                            <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                                <CustomData
                                    titleText="massive.echeck.debit.account"
                                    titleTextType="I18N"
                                    valueText={formatAccountBody(accountInfo)}
                                />
                                <CustomData
                                    titleText="payments.newPayment.filesMetadata.label"
                                    titleTextType="I18N"
                                    valueText={processedFileData?.filesMetadata?.fileName}
                                />
                                <CustomData
                                    titleText="payments.newPayment.dateProcess.label"
                                    titleTextType="I18N"
                                    valueText={<FormattedDate date={Date.now()} dateFormat="DD/MM/YYYY" />}
                                />
                                <CustomData
                                    titleText="echeq.request.amount.label"
                                    titleTextType="I18N"
                                    valueText={processedFileData?.validLines}
                                />
                            </div>
                            {isTicket && (
                                <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                                    <MassiveEcheckTable
                                        transactionStatus={transaction.idTransactionStatus}
                                        fromTransactionPage
                                        isDesktop={isDesktop}
                                        debitAccount={formatAccountBody(accountInfo)}
                                    />
                                    <TransactionSign creationTime isDesktop={isDesktop} showMoreData={showMoreData} />
                                </div>
                            )}
                        </>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className="grid-table echeq-massive-emit echeq-massive-emit-details form-summary">
            <CustomData
                dataClass="emisor"
                titleText="massive.echeck.debit.account"
                titleTextType="I18N"
                valueText={formatAccountBody(accountInfo)}
            />
            <CustomData
                dataClass="dateprocess"
                titleText="payments.newPayment.dateProcess.label"
                titleTextType="I18N"
                valueText={<FormattedDate date={Date.now()} dateFormat="DD/MM/YYYY" />}
            />
            <CustomData
                dataClass="echeqs"
                titleText="echeq.request.amount.label"
                titleTextType="I18N"
                valueText={processedFileData?.validLines}
            />
            <CustomData
                dataClass="amount"
                titleText="forms.inputFile.massivePayments.totalAmount"
                titleTextType="I18N"
                valueText={
                    <FormattedAmount
                        className="data-label"
                        currency={processedFileData?.totalAmount?.currency}
                        quantity={processedFileData?.totalAmount?.quantity}
                    />
                }
            />
            <CustomData
                dataClass="filename"
                titleText="payments.newPayment.filesMetadata.label"
                titleTextType="I18N"
                valueText={processedFileData?.filesMetadata?.fileName}
            />
            <div className="view-more-data-button">
                <div className="horizontal-divider" />
                <div className="ticket__divider inside-ticket__body">
                    <div className="ticket__notch ticket__notch--left"> </div>
                    <div className="ticket__notch ticket__notch--right"> </div>
                </div>
                <Button
                    aria-expanded={showMoreData ? "true" : "false"}
                    className="more-button"
                    label={buttonLabel}
                    bsStyle="link"
                    onClick={handleSeeMoreData}
                    image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                />
            </div>
            <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                <MassiveEcheckTable isDesktop={isDesktop} debitAccount={formatAccountBody(accountInfo)} />
            </div>
        </div>
    );
};

MassiveEcheckSummaryBody.propTypes = {
    file: arrayOf(
        shape({
            fileId: number,
            fileName: string,
            fileSize: number,
        }),
    ).isRequired,
    processedFileData: shape({
        fileIdentifier: string,
        fileName: string,
        totalAmount: shape({
            quantity: number,
            currency: string,
        }),
        fromTransactionPage: false,
    }).isRequired,
    accountInfo: shape({}).isRequired,
    isDesktop: bool.isRequired,
    fromTransactionPage: bool,
    showMoreData: bool,
    setShowMoreData: func,
    isTicket: bool,
};

MassiveEcheckSummaryBody.defaultProps = {
    fromTransactionPage: false,
    showMoreData: false,
    setShowMoreData: () => {},
    isTicket: true,
};

export default MassiveEcheckSummaryBody;
